var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-container vribbon" }, [
    _c(
      "div",
      {
        class: {
          "flex-row": true,
          "flex-1": true,
          "gray-bg": _vm.isNewUi,
          handCursor: _vm.hasAction,
        },
        on: { click: _vm.clickAction },
      },
      [
        _c("div", { staticClass: "flex-col flex-1 rotate ribonvalue" }, [
          _c(
            "div",
            {
              staticClass: "flex-row rotate-content",
              attrs: { id: "ribbonValue" },
            },
            [_vm._v(_vm._s(_vm.ribbonValue))]
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "flex-col flex-1 rotate blueBox whiteFont textnowrap",
          },
          [
            _c(
              "div",
              {
                staticClass: "flex-row rotate-content",
                attrs: { id: "ribbonText" },
              },
              [_vm._v(_vm._s(_vm.ribbonText))]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }